module.exports = __webpack_public_path__ + "media/images/users/avatar-45b6058e10561838e4f26103fdb28660.jpg";